import { module } from 'modujs';

import { Datepicker } from 'vanillajs-datepicker';


export default class extends module {
    constructor(m) {
        super(m);

    }
    init() {

        const datepicker = new Datepicker(this.el, {
            maxDate : new Date(),
            startView : 2,
            autohide: true,
            format: 'dd/mm/yyyy'
        });
    }
    destroy(){}
}
